import { generateTestId } from "@client-shared";

export const PRODUCT_SELECT_FORM_TEST_ID_KEYS = {
  COMPONENT: "productSelectForm",
  DESCRIPTION: {
    CONTAINER: "container",
    SEARCH_INPUT: "search-input",
    PRODUCT_LIST: "product-list",
    EMPTY_STATE: "empty-state",
    LOADING_STATE: "loading-state",
    ERROR_STATE: "error-state",
  },
};

export const getProductSelectFormTestIds = (testId?: string) => {
  const baseId = testId ?? PRODUCT_SELECT_FORM_TEST_ID_KEYS.COMPONENT;
  return {
    containerTestId: generateTestId(baseId, PRODUCT_SELECT_FORM_TEST_ID_KEYS.DESCRIPTION.CONTAINER),
    searchInputTestId: generateTestId(baseId, PRODUCT_SELECT_FORM_TEST_ID_KEYS.DESCRIPTION.SEARCH_INPUT),
    productListTestId: generateTestId(baseId, PRODUCT_SELECT_FORM_TEST_ID_KEYS.DESCRIPTION.PRODUCT_LIST),
    emptyStateTestId: generateTestId(baseId, PRODUCT_SELECT_FORM_TEST_ID_KEYS.DESCRIPTION.EMPTY_STATE),
    loadingStateTestId: generateTestId(baseId, PRODUCT_SELECT_FORM_TEST_ID_KEYS.DESCRIPTION.LOADING_STATE),
    errorStateTestId: generateTestId(baseId, PRODUCT_SELECT_FORM_TEST_ID_KEYS.DESCRIPTION.ERROR_STATE),
  };
};
